module.exports = __webpack_public_path__ + "img/one-page-plan-icon.fe0c072d.svg";